import { Injectable } from '@angular/core';
import { TokenKeeper } from './tokenKeeper';

@Injectable({
  providedIn: 'root',
})
export class TokenFacade {
  #tokenKeeper = TokenKeeper.getPlatformSingleton();
  token$ = this.#tokenKeeper.token$;
  tokenPayload$ = this.#tokenKeeper.tokenPayload$;

  /**
   * There were multiple places where the token could potentially be undefined or null,
   * so I just allowed them to be passed in but ignored.
   */
  setToken(newToken: string | null | undefined) {
    if (newToken) {
      this.#tokenKeeper.setToken(newToken);
    }
  }

  clearToken() {
    this.#tokenKeeper.clearToken();
  }

  getToken() {
    return this.#tokenKeeper.getToken();
  }

  getTokenFromLocalStorage() {
    return this.#tokenKeeper.getTokenFromLocalStorage();
  }

  getPayloadFromLocalStorage() {
    return this.#tokenKeeper.getPayloadFromLocalStorage();
  }
}
